import "./App.css";
import { Link } from "react-router-dom";
function About() {
  return (
    <div className="">
      <div className="absolute top-14 text-center w-[80%] ml-[10%] z-50"></div>
      <div className="applyImg fixed"></div>
      <div className="App">
        <div className="h-38"></div>
        <header className="bg-zinc-900/90 drop-shadow-lg text-zinc-200 top-0 z-10 w-[80%] pb-8 ml-[10%] text rounded-xl">
          <div className="text-3xl pt-4 font-semibold">
            Welcome to Omnicraft SMP
          </div>
          <div className="text-xl mt-2">
            A Friendly & Modded Minecraft Community
          </div>

          <div>
            <div className="mt-4 text-md">
              <div className="lg:mx-[10%] mx-[5%]">
                We are a welcoming and cooperative Minecraft server where
                players come together to build, explore, and thrive in a
                friendly community. Whether you're a seasoned adventurer/fighter
                or a casual builder, there's a place for you here!
              </div>
              <div className="mt-4 text-2xl font-bold">Modded Gameplay</div>
              <div className="lg:mx-[10%] mx-[5%] ">
                Experience a fresh take on Minecraft with carefully selected
                mods that enhance the game while keeping the spirit of
                creativity and collaboration alive. All Client Mods are allowed
                there is no restrictions, play how you want to play. Server side
                mods suggestions are open all season. Mods that are both Client
                and Server can only be suggested in between each season when we
                rebuild and update the modpack.
              </div>
              <div className="mt-4 text-2xl font-bold">Community Driven</div>
              <div className="lg:mx-[10%] mx-[5%]">
                Work together here on ambitious builds, tackle exciting
                challenges, or just relax and enjoy the game with like-minded
                players. Worried about grief or PvP? Claim you land and protect
                it from all damage.
              </div>
              <div className="mt-4 text-2xl font-bold">Balanced Adventure</div>
              <div className="lg:mx-[10%] mx-[5%]">
                While cooperation is encouraged, the world is filled with
                adventure, exploration, and just the right amount of challenge
                to keep things interesting! If PvP is your thing, find
                likeminded players and challenge them. With our mods there will
                always be something for you to do here.
              </div>
              <div className="lg:mx-[10%] mx-[5%] mt-4">
                Join us and become part of an amazing community where
                creativity, teamwork, and fun are at the heart of everything we
                do!
              </div>
            </div>

            <Link to="/application" className="flex link flex-row-reverse mt-8">
              <button
                type="submit"
                className="themeBg hover:bg-gray-700 mx-[5%] text text-xl font-semibold text-zinc-200 py-1.5 px-3 rounded-3xl flex"
              >
                <span className="mr-2 link ">Apply Now</span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6 mt-0.5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25"
                    />
                  </svg>
                </span>
              </button>
            </Link>
          </div>
        </header>
        <div className="h-34"></div>
      </div>
    </div>
  );
}
export default About;
